import React, { useState, useEffect } from 'react';
import { GanttContext } from './gantt-context';
import axios, { endpoints } from 'src/utils/axios';
import { baseURLStaging } from 'src/config-global';
import { useRouter, useSearchParams } from 'src/routes/hooks';
import { deleteRequest, deleteRequestGantt, getRequest, postRequest } from 'src/services';
import { handleErrorMessages } from 'src/components/risk-management/risk-register/feching';

export const GanttProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const router = useRouter();
  const [resourseData, setResourseData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [completeData, setCompleteData] = useState(null);
  const [backupData, setBackupData] = useState(null);
  const [getDateWiseAssigmentLoading, setGetDateWiseAssigmentLoading] = useState(false);
  const [dateWiseAssignData,setDateWiseAssignData]=useState(null)
  const [dateWiseMaterials,setDateWiseMaterials]=useState(null)
  const [dateWiseMaterialsLoading,setDateWiseMaterialsLoading]=useState(null)
  const [dateWiseEquipments,setDateWiseEquipments]=useState(null)
  const [dateWiseEquipmentsLoading,setDateWiseEquipmentsLoading]=useState(null)
  const [dateWiseSubcontractorLoading,setDateWiseSubcontractorLoading]=useState(null)
  const [dateWiseSubcontractor,setDateWiseSubcontractor]=useState(null)
  const [dateWiseOtherCostLoading,setDateWiseOtherCostLoading]=useState(false)
  const [dateWiseOtherCost,setDateWiseOtherCost]=useState(null)
  const [defaultVisibleColumn,setDefaultVisibleColumn]=useState({
    wbs: false,
    text: true,
    start_date: true,
    finish_date: false,
    duration: true,
    total_duration: false,
    add: true,
    predecessor: false,
    successor: false,
    budgeted_amount: false,
    budgeted_hours: false,
    performed_amount: false,
    performed_hours: false,
    percentage: false,
    totalSlack: false,
    freeSlack: false,
    actual_start_date: false,
    owner: true,
  })
  useEffect(() => {
    storePrivateKeys();
  }, [router]);

  useEffect(() => {
    const storedColumns = sessionStorage.getItem("visibleColumns");
    if (storedColumns) {
      setDefaultVisibleColumn(JSON.parse(storedColumns));
    }
  }, []);

  const storePrivateKeys = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const initialAuthToken = searchParams.get('token') || localStorage.getItem('authToken') || '';
    const initialProjectId =
      searchParams.get('project_id') || localStorage.getItem('projectId') || '';
    const initialCompanyId =
      searchParams.get('company_id') || localStorage.getItem('companyId') || '';
    localStorage.setItem('authToken', initialAuthToken);
    localStorage.setItem('projectId', initialProjectId);
    localStorage.setItem('companyId', initialCompanyId);
  };

  const fetchGanttData = async () => {
    setLoading(true);
    try {
      const custom = await getRequest(`/gantt-chart-cost-codes`);
      if (custom) {
        setCompleteData(custom);
        const data = {
          data: custom.gantt_resources.data.map(item => ({
            ...item,
            duration: item.total_duration,
            total_duration: item.duration,
          })),
          links: custom.gantt_resources.links,
          assignments: custom.gantt_resources.assignments,
          resources_activity: custom.gantt_resources.resources_activity,
          resources_title: custom.gantt_resources.resources_title,
        };
        setData(data);
      }
    } catch (error) {
      console.error('Error fetching Gantt chart data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAssignData = async () => {
    setLoading(true);
    try {
      const custom = await getRequest(`/gantt-chart-cost-codes?resource_assignment=true`); // Fixed typo

      if (custom) {
        setCompleteData(custom);
        const data2 = {
          data: custom.gantt_resources.data.map(item => ({
            ...item,
            duration: item.total_duration,
            total_duration: item.duration,
          })), // Deep copy with date conversion and duration swap
          resources: [...custom.gantt_resources.resources_title], // Deep copy
        };
        setResourseData(data2);
        setBackupData(JSON.parse(JSON.stringify(data2))); // Ensure deep copy
        return data2
      }
    } catch (error) {
      console.error('Error fetching Gantt chart data:', error);
    } finally {
      setLoading(false);
    }
  };

  const assignHours = async (apiData,gantt) => {
    if (!apiData.type) {
      // if(apiData["!nativeeditor_status"]=="updated"){
        const data = {
          resource_id: apiData.resource_id,
          task_id: apiData.task_id,
          value: apiData.value,
          start_date: apiData.start_date.split(' ')[0],
          end_date: apiData.end_date.split(' ')[0],
          planned_assigned_labor_id: apiData.planned_assigned_labor_id,
        };
  
        try {
          const response = await postRequest(endpoints.ganttChart.assign_hours, data, false);
          if (!(response.metadata && response.metadata.success)) {
            throw new Error(response?.message || 'Failed to assign hours');
          }
        } catch (err) {
    
          const response=   await fetchAssignData();
          gantt.parse(response);
          console.error('Error:', err);
          // setResourseData(JSON.parse(JSON.stringify(backupData))); // Restore deep copy
          handleErrorMessages(err.message || 'Submission failed.');
          // return err.message;
        }
    
    }

  };
  const getDateWiseAssigment = async (date) => {
    setGetDateWiseAssigmentLoading(true);
    try {
      const custom = await getRequest(`${endpoints.ganttChart.assign_labours}?date=${date}`); // Fixed typo

      if (custom) {
        setDateWiseAssignData(custom)
      }
    } catch (error) {
      console.error('Error fetching Gantt chart data:', error);
    } finally {
      setGetDateWiseAssigmentLoading(false);
    }
  };



  const getDateWiseMaterials = async (date) => {
    setDateWiseMaterialsLoading(true);
    try {
      const custom = await getRequest(`${endpoints.ganttChart.assign_materials}?date=${date}`); // Fixed typo

      if (custom) {
        setDateWiseMaterials(custom)
      }
    } catch (error) {
      console.error('Error fetching Gantt chart data:', error);
    } finally {
      setDateWiseMaterialsLoading(false);
    }
  };
  const getDateWiseEquipments = async (date) => {
    setDateWiseEquipmentsLoading(true);
    try {
      const custom = await getRequest(`${endpoints.ganttChart.assign_equipments}?date=${date}`); // Fixed typo

      if (custom) {
        setDateWiseEquipments(custom)
      }
    } catch (error) {
      console.error('Error fetching Gantt chart data:', error);
    } finally {
      setDateWiseEquipmentsLoading(false);
    }
  };
  const getDateWiseSubcontractor = async (date) => {
    setDateWiseSubcontractorLoading(true);
    try {
      const custom = await getRequest(`${endpoints.ganttChart.assign_subcontractor}?date=${date}`); // Fixed typo

      if (custom) {
        setDateWiseSubcontractor(custom)
      }
    } catch (error) {
      console.error('Error fetching Gantt chart data:', error);
    } finally {
      setDateWiseSubcontractorLoading(false);
    }
  };
  const getDateWiseOtherCost = async (date) => {
    setDateWiseOtherCostLoading(true);
    try {
      const custom = await getRequest(`${endpoints.ganttChart.assign_othercost}?date=${date}`); // Fixed typo

      if (custom) {
        setDateWiseOtherCost(custom)
      }
    } catch (error) {
      console.error('Error fetching Gantt chart data:', error);
    } finally {
      setDateWiseOtherCostLoading(false);
    }
  };

  const onDrop = async (apiData,gantt) => {
      try {
        const response = await postRequest(`${endpoints.ganttChart.onDrop}?_method=PUT`, apiData, false);

        if (!(response.metadata && response.metadata.success)) {
          const response=   await fetchAssignData();
          gantt.parse(response);
          throw new Error(response?.message || 'Failed to drag');
        }
      } catch (err) {
          
        const response=   await fetchAssignData();
        gantt.parse(response);
        console.error('Error:', err);
        handleErrorMessages(err.message || 'Submission failed.');
        return err.message;
      }
  };
  const onAddLink = async (apiData,gantt) => {
      try {
        const response = await postRequest(`${endpoints.ganttChart.onAddLink}`, apiData, false);
        if(response.metadata && response.metadata.success){
          return response.payload
         }else if (!(response.metadata && response.metadata.success)) {
          const response=   await fetchAssignData();
          gantt.parse(response);
          throw new Error(response?.message || 'Failed to Add Link');
        }
      } catch (err) {
        const response=   await fetchAssignData();
        gantt.parse(response);
        console.error('Error:', err);
        handleErrorMessages(err.message || 'Submission failed.');
        return err.message;
      }
  };
  const removeLink = async (id,gantt) => {
      try {
        const response = await deleteRequestGantt(`${endpoints.ganttChart.onAddLink}/${id}`);
         if(response.metadata && response.metadata.success){
          return response
         }else if (!(response.metadata && response.metadata.success)) {
          const response=   await fetchAssignData();
          gantt.parse(response);
          throw new Error(response?.message || 'Failed to Remove Link');
        }
      } catch (err) {
        const response=   await fetchAssignData();
        gantt.parse(response);
        console.error('Error:', err);
        handleErrorMessages(err.message || 'Submission failed.');
        // return err.message;
      }
  };

  const handleColumnChange = (event) => {
    setDefaultVisibleColumn({
      ...defaultVisibleColumn,
      [event.target.name]: event.target.checked,
    });
    sessionStorage.setItem("visibleColumns", JSON.stringify({
      ...defaultVisibleColumn,
      [event.target.name]: event.target.checked,
    }));
  };

  return (
    <GanttContext.Provider
      value={{
        data,
        resourseData,
        loading,
        refreshData: fetchGanttData,
        refreshAssignData: fetchAssignData,
        completeData,
        assignHours: assignHours,
        getDateWiseAssigmentLoading,
        getDateWiseAssigment,
        dateWiseAssignData,
        getDateWiseMaterials,
        dateWiseMaterialsLoading,
        dateWiseMaterials,
        getDateWiseEquipments,
        dateWiseEquipmentsLoading,
        dateWiseEquipments,
        getDateWiseSubcontractor,
        dateWiseSubcontractorLoading,
        dateWiseSubcontractor,
        onDrop,
        dateWiseOtherCostLoading,
        dateWiseOtherCost,
        getDateWiseOtherCost,
        defaultVisibleColumn,
        handleColumnChange,
        onAddLink,
        removeLink
      }}
    >
      {children}
    </GanttContext.Provider>
  );
};
